<template>
  <VaButton
    preset="plain"
    size="small"
    class="theme-toggle-button"
    :title="theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
    @click="toggleTheme"
  >
    <VaIcon :name="theme === 'dark' ? 'light_mode' : 'dark_mode'" size="small" />
  </VaButton>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from '../../../stores/theme-store'

const { t } = useI18n()
const themeStore = useThemeStore()

const theme = computed(() => themeStore.theme)

// Toggle theme function
const toggleTheme = () => {
  const newTheme = theme.value === 'dark' ? 'light' : 'dark'
  themeStore.setTheme(newTheme)
}
</script>

<style lang="scss" scoped>
.theme-toggle-button {
  border: none !important;
  background: transparent !important;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition:
    transform 0.15s ease,
    opacity 0.15s ease;
  position: relative;
  overflow: visible;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1 !important;
  visibility: visible !important;
  color: var(--va-navbar-text-color, #000000) !important;

  &:hover {
    background: transparent !important;
    transform: scale(1.08);
  }

  &:active {
    transform: scale(0.95);
  }

  :deep(.va-button__content) {
    color: var(--va-navbar-text-color, #000000) !important;
    opacity: 1 !important;
  }

  .va-icon {
    transition: opacity 0.15s ease;
    color: var(--va-navbar-text-color, #000000) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  &:hover .va-icon {
    opacity: 0.9;
  }
}
</style>
